module.exports = __webpack_public_path__ + "static/img/095_TO8_1771.38facbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/095_TO8_1771.jpg
// module id = 8Ekh
// module chunks = 0